/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', initLoadMore);
document.addEventListener('shopify:section:load', initLoadMore);

function initLoadMore() {
  const btn = document.getElementById('LoadMoreBtn');
  if (!btn || btn.dataset.bound === 'true') return;

  btn.dataset.bound = 'true';

  btn.addEventListener('click', async function () {
    const nextUrl = btn.dataset.nextUrl;
    const currentMain = document.getElementById('CollectionMain');
    const currentList = currentMain ? currentMain.querySelector('product-list') : null;

    if (!nextUrl || !currentMain || !currentList) return;

    btn.disabled = true;
    btn.textContent = 'Caricamento...';

    try {
      const response = await fetch(nextUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      const htmlText = await response.text();
      const doc = new DOMParser().parseFromString(htmlText, 'text/html');

      const fetchedMain = doc.getElementById('CollectionMain');
      const fetchedList = fetchedMain ? fetchedMain.querySelector('product-list') : null;
      const fetchedBtn = doc.getElementById('LoadMoreBtn');

      if (!fetchedMain || !fetchedList) {
        btn.textContent = 'Nessun altro prodotto';
        return;
      }

      const mergedMain = currentMain.cloneNode(true);
      const mergedList = mergedMain.querySelector('product-list');

      mergedList.innerHTML = currentList.innerHTML + fetchedList.innerHTML;

      const oldWrapper = mergedMain.querySelector('.load-more-wrapper');
      if (oldWrapper) oldWrapper.remove();

      if (fetchedBtn && fetchedBtn.dataset.nextUrl) {
        const newWrapper = document.createElement('div');
        newWrapper.className = 'load-more-wrapper';
        newWrapper.innerHTML = `
          <button
            id="LoadMoreBtn"
            class="button"
            type="button"
            data-next-url="${fetchedBtn.dataset.nextUrl}">
            Carica altri prodotti
          </button>
        `;
        mergedMain.appendChild(newWrapper);
      }

      currentMain.replaceWith(mergedMain);
      initLoadMore();
    } catch (error) {
      console.error('Load more error:', error);
      btn.disabled = false;
      btn.textContent = 'Errore, riprova';
    }
  });
}